<template>
    <form @submit.prevent>



        <div class="form-container settings-form padl20">

            <h3 class="block-header mb-6">Global Settings </h3>
            <div v-if="[1].indexOf(getUserRoleId) <= -1">
                <h3 class="small-header pl-0">Multi-Factor Authentication</h3>
                <div class="vx-col w-full">
                        <div class="form_group d-flex align-center">
                            <p class="form_label mb-0">Enable MFA</p>
                            <div class="table_switch mb-0 ml-4">
                                <vs-switch class="mb-0" v-model="config.mfaRequired" @click="conformMaf">
                                    <span slot="on">Yes</span>
                                    <span slot="off">No</span>
                                </vs-switch>
                            </div>
                        </div>

                    <div v-if="config.mfaRequired" class="vx-col global-settings">
                        <form @submit.prevent data-vv-scope="mfaAuthentication">
                            <div class="vx-col w-full">
                                <div class="form_group">
                                    <p> Allow <vs-input :key="'gracePeriodInDays'" :maxLength="3"
                                            oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');"
                                            class="textfiled" name="gracePeriodInDays" icon-pack="feather" v-validate="'required'"
                                            data-vv-as="Grace period" icon-after v-model="config.mfaConfig.gracePeriodInDays" />
                                            days grace period to make it mandatory for users.
                                    </p>
                                    <span v-show="errors.has('mfaAuthentication.gracePeriodInDays')" class="text-danger">
                                        {{ errors.first('mfaAuthentication.gracePeriodInDays') }}
                                    </span>
                                </div>
                            </div>
                            <div  v-if="checkProperty(config['mfaConfig'], 'enableTo','length') > 0" v-for="(user, index) in config.mfaConfig.enableTo" :key="user._id" class="form_group align-center">
                                <p v-if="index === 0" class="form_label mb-3 d-block">Enable to</p>
                                <div class="table_switch mb-0 ml-4">
                                    <vs-checkbox :name="'selected_' +index" :key="user._id"
                                    v-model="user.enable" class="" @click="checkValidation">
                                    <p class="form_label mb-0">{{ user.name }}</p>
                                    </vs-checkbox>
                                </div>
                            </div>
                            <span v-if="showMfaError" class="text-danger gbl_setting_error">*Please select at least one option</span>
                        </form>
                    </div>
                    <div class="form_group d-flex align-center">
                            <p class="form_label mb-0">Accept Consent and Terms and Conditions</p>
                            <div class="table_switch mb-0 ml-4">
                                <vs-switch class="mb-0" v-model="config.acceptConsentAndTAndC">
                                    <span slot="on">Yes</span>
                                    <span slot="off">No</span>
                                </vs-switch>
                            </div>
                        </div>


                    </div>
            </div>
            <h3 class="small-header pl-0">General</h3>
            <div class="vx-row">
                <template v-if="[1].indexOf(getUserRoleId) > -1">

                    <div class="vx-col w-full">

                        <div class="form_group">

                            <p>How <vs-input :key="'priorFormsEffectiveDays'"
                                    oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');"
                                    class="textfiled" name="priorFormsEffectiveDays" icon-pack="feather"
                                    v-validate="'numeric'" data-vv-as="Case default deadline days" icon-after
                                    v-model="config.priorFormsEffectiveDays" /> days prior need to display new Forms?</p>



                        </div>

                    </div>

                    <template>

                        <div class="accordian-table seasonstable">

                            <h3 class="small-header mt-2">Cap Registrations</h3>

                            <div class="vs-table--content" v-if="checkProperty(capSeasonEffectiveList, 'length') > 0">

                                <div class="vs-con-tbody">

                                    <table class="vs-table vs-table--tbody-table">

                                        <thead class="vs-table--thead">

                                            <tr>

                                                <th>

                                                    <div class="vs-table-text">

                                                        Season Year

                                                    </div>

                                                </th>

                                                <th>

                                                    <div class="vs-table-text">

                                                        Effective Date

                                                    </div>

                                                </th>

                                            </tr>

                                        </thead>

                                        <template v-if="checkProperty(capSeasonEffectiveList, 'length') > 0">

                                            <tr class="vs-table--tr" v-for="(season, index) in capSeasonEffectiveList"
                                                :key="index">

                                                <td class="td vs-table--td">

                                                    <span>

                                                        <div class="cursor-pointer"> {{ checkProperty(season, 'seasonYear'
                                                        ) }} </div>

                                                    </span>

                                                </td>

                                                <td class="td vs-table--td">

                                                    <span>

                                                        <div class="cursor-pointer"> {{ checkProperty(season,
                                                            'effectiveDate') | formatDate }} </div>

                                                    </span>

                                                </td>

                                                <td class="td vs-table--td">

                                                    <span class="cursor-pointer" @click="deleteSeason(season)">

                                                        <img src="@/assets/images/main/delete-row-img.svg" />

                                                    </span>

                                                </td>

                                            </tr>

                                        </template>



                                    </table>

                                </div>

                            </div>

                        </div>

                        <a @click="addSeasonYears(true)" class="add-more ml-4" type="filled">

                            <span>+</span>&nbsp;<template v-if="checkProperty(capSeasonEffectiveList, 'length') > 0">Add
                                More</template><template v-else>Add CAP Season Year</template>

                        </a>



                        <!-- <span @click="addSeasonYears(true)">Add More</span> -->

                    </template>

                    <vs-popup id="seasonsPopup" class="holamundo main-popup" title="Add Season"
                        :active.sync="showAddseasonsPopup">

                        <form data-vv-scope="showAddseasonsPopup">

                            <div class="form-container">

                                <div class="vx-row" @click="seasonnYearError = ''">

                                    <immiInput :display="true" :cid="'seasonYear'" :formscope="'showAddseasonsPopup'"
                                        v-model="seletedObj.seasonYear" :required="true" :fieldName="'seasonYear'"
                                        label="Season" placeHolder="Season" />

                                    <selectField v-if="false" :display="true" :listContainsId="false"
                                        :formscope="'showAddseasonsPopup'" :required="true" :optionslist="seasonsYears"
                                        v-model="seletedObj.seasonYear" :fieldName="'seasonYear'" label="Select Season"
                                        placeHolder="Select Season" />

                                    <datepickerField :display="true" :formscope="'showAddseasonsPopup'"
                                        :validationRequired="true" v-model="seletedObj.effectiveDate" label="Effective Date"
                                        :fieldName="'effectiveDate'" />

                                    <!-- {{ selectedSeasonYear(seletedObj.seasonYear) }} -->

                                </div>

                                <div class="text-danger text-sm formerrors custom_margin" v-show="seasonnYearError">

                                    <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius"
                                        icon-pack="IntakePortal" icon="IP-information-button" active="true">{{
                                            seasonnYearError }}</vs-alert>

                                </div>

                            </div>

                            <div class="popup-footer">

                                <vs-button color="dark" class="cancel" type="filled"
                                    @click="addSeasonYears(false)">Cancel</vs-button>

                                <vs-button color="success" class="save" type="filled"
                                    @click="addSeasonstoList">Submit</vs-button>

                            </div>

                        </form>

                    </vs-popup>



                </template>

                <template v-else>
                    <div class="vx-col w-full">
                        <div class="form_group d-flex align-center">
                            <p class="form_label mb-0">Enable I-9 Requests</p>
                            <div class="table_switch mb-0 ml-4">
                                <vs-switch class="mb-0" v-model="config.enableI9Requests">
                                    <span slot="on">Yes</span>
                                    <span slot="off">No</span>
                                </vs-switch>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col w-full">
                        <div class="form_group d-flex align-center">
                            <p class="form_label mb-0">Enable PAF Requests</p>
                            <div class="table_switch mb-0 ml-4">
                                <vs-switch class="mb-0" v-model="config.enablePAFRequests">
                                    <span slot="on">Yes</span>
                                    <span slot="off">No</span>
                                </vs-switch>
                            </div>
                        </div>
                    </div>



                    <div class="vx-col w-full">

                        <div class="form_group d-flex align-center">

                            <p class="form_label mb-0">Assign Case Numbers manually?</p>

                            <div class="table_switch mb-0 ml-4">

                                <vs-switch class="mb-0" v-model="config.allowCustonCaseNo">

                                    <span slot="on">Yes</span>

                                    <span slot="off">No</span>

                                </vs-switch>

                            </div>

                        </div>

                    </div>
                    <div class="vx-col w-full">
                    <div class="form_group d-flex align-center">
                        <p class="form_label mb-0">Show Case Deadline Date to Petitioner</p>
                        <div class="table_switch mb-0 ml-4">
                            <vs-switch class="mb-0" v-model="config.showCaseDeadLineDateforPetitioner">
                                <span slot="on">Yes</span>
                                <span slot="off">No</span>
                            </vs-switch>
                        </div>
                    </div>
                    </div>

                    <div class="vx-col w-full">

                        <div class="form_group d-flex align-center">

                            <p class="form_label mb-0">Will Petitioner act as USCIS forms preparer?</p>

                            <div class="table_switch mb-0 ml-4">

                                <vs-switch class="mb-0" v-model="config.isPtnrActAsUSCISFormsPreparer">

                                    <span slot="on">Yes</span>

                                    <span slot="off">No</span>

                                </vs-switch>

                            </div>

                        </div>

                    </div>

                    <div class="vx-col w-full">

                        <div class="form_group d-flex align-center">

                            <p class="form_label mb-0">Use Petitioner Address as mailing address for USCIS?</p>

                            <div class="table_switch mb-0 ml-4">

                                <vs-switch class="mb-0" v-model="config.usePtnrAddrAsMailingAddrInUSCISForms">

                                    <span slot="on">Yes</span>

                                    <span slot="off">No</span>

                                </vs-switch>

                            </div>

                        </div>

                    </div>

                    <div class="vx-col w-full">

                        <div class="form_group d-flex align-center">

                            <p class="form_label mb-0">Accept Company Documents for Petitioner </p>

                            <div class="table_switch mb-0 ml-4">

                                <vs-switch class="mb-0" v-model="config.acceptCompayDocsForPtnr">

                                    <span slot="on">Yes</span>

                                    <span slot="off">No</span>

                                </vs-switch>

                            </div>

                        </div>

                    </div>

                    <div class="vx-col w-full">

                        <div class="form_group d-flex align-center">

                            <p class="form_label mb-0">Allow to manage External Cases </p>

                            <div class="table_switch mb-0 ml-4">

                                <vs-switch class="mb-0" v-model="config.isAllowExternalCases">

                                    <span slot="on">Yes</span>

                                    <span slot="off">No</span>

                                </vs-switch>

                            </div>

                        </div>

                    </div>

                    <div class="vx-col w-full">

                        <div class="form_group d-flex align-center">

                            <p class="form_label mb-0">Does PIN is required to submit questionnaire through link? </p>

                            <div class="table_switch mb-0 ml-4">



                                <vs-switch class="mb-0" v-model="config.requiredPinForQuesSubmit">

                                    <span slot="on">Yes</span>

                                    <span slot="off">No</span>

                                </vs-switch>

                            </div>

                        </div>

                    </div>



                    <div class="vx-col w-full">

                        <div class="form_group d-flex align-center">

                            <p class="form_label mb-0">Prefill Country Details in Questionnaire?</p>

                            <div class="table_switch mb-0 ml-4">

                                <vs-switch class="mb-0" v-model="config.prefillCountryInQuestionnaire">

                                    <span slot="on">Yes</span>

                                    <span slot="off">No</span>

                                </vs-switch>

                            </div>

                        </div>

                    </div>

                    <!-----prefillCountryInQuestionnaire-->

                    <div class="vx-col w-full">



                        <div class="form_group d-flex align-center">

                            <p class="form_label mb-0">Allow to complete Petitioner and Attorney signature? </p>

                            <div class="table_switch mb-0 ml-4">

                                <vs-switch class="mb-0" v-model="config.ptnrAttorneySignByInternal">

                                    <span slot="on">Yes</span>

                                    <span slot="off">No</span>

                                </vs-switch>

                            </div>

                        </div>

                    </div>



                    <!-----ptnrAttorneySignByInternal Allow to complete Petitioner and Attorney signature -->





                    <div class="vx-col w-full">

                        <div class="form_group d-flex align-center">

                            <p class="form_label mb-0">Does the Task need acceptance before being assigned? </p>

                            <div class="table_switch mb-0 ml-4">

                                <vs-switch class="mb-0" v-model="config.taskApprovalRequired">

                                    <span slot="on">Yes</span>

                                    <span slot="off">No</span>

                                </vs-switch>

                            </div>

                        </div>

                    </div>

                    <div class="vx-col w-full" v-if="[3].indexOf(getUserRoleId) > -1 && getTenantTypeId != 2">

                        <div class="form_group d-flex align-center">

                            <p class="form_label mb-0">Do you want to sync your invoices in QuickBooks? </p>

                            <div class="table_switch mb-0 ml-4">

                                <vs-switch class="mb-0" v-model="config.requiredQBForInvoice">

                                    <span slot="on">Yes</span>

                                    <span slot="off">No</span>

                                </vs-switch>

                            </div>

                        </div>

                    </div>
                    <div class="vx-col w-full" v-if="[3].indexOf(getUserRoleId) > -1">

                        <div class="form_group d-flex align-center">

                            <p class="form_label mb-0">Do you want to enable custom reports? </p>

                            <div class="table_switch mb-0 ml-4">

                                <vs-switch class="mb-0" v-model="config.showCustomReports">

                                    <span slot="on">Yes</span>

                                    <span slot="off">No</span>

                                </vs-switch>

                            </div>

                        </div>

                    </div>



                    <div class="vx-col w-full">

                        <div class="form_group">



                            <p>RFE Case should be filed<vs-input :key="'rfeCaseDeadlineDays'"
                                    oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');"
                                    class="textfiled" name="rfeCaseDeadlineDays" icon-pack="feather" v-validate="'numeric'"
                                    data-vv-as="Case default deadline days" icon-after
                                    v-model="config.rfeCaseDeadlineDays" /> days prior to the USCIS deadline.</p>



                        </div>

                    </div>



                    <div class="vx-col w-full">

                        <div class="form_group">

                            <p>Case to be filed within <vs-input :key="'caseDeadlineDays'"
                                    oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');"
                                    class="textfiled" name="caseDeadlineDays" icon-pack="feather" v-validate="'numeric'"
                                    data-vv-as="Case default deadline days" icon-after v-model="config.caseDeadlineDays" />
                                days since it was submitted to the Law Firm.</p>



                        </div>

                    </div>

                    <div class="vx-col w-full">

                        <div class="form_group">

                            <p>Consider <vs-input :key="'priorI94DeadlineDays'"
                                    oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');"
                                    class="textfiled" name="priorI94DeadlineDays" icon-pack="feather" v-validate="'numeric'"
                                    data-vv-as="I-94 prior deadline days" icon-after
                                    v-model="config.priorI94DeadlineDays" /> days prior to the expiry of I-94 to set
                                deadline to file the case. </p>



                        </div>

                    </div>



                    <div class="vx-col w-full">

                        <div class="form_group">
                            <p>Send tasks brief every <vs-input :key="'ClientId'" class="textfiled" name="ClientId"
                            oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');"
                            icon-pack="feather" v-validate="'numeric'" data-vv-as="Briefing Days" icon-after
                            v-model="config.ptnrBriefDays" /> day(s).</p>
                        </div>
                    </div>
                    <div class="vx-col w-full">
                        <div class="form_group">
                            <p> Wait <vs-input :key="'BenfSubQuest'" class="textfiled" name="BenfSubQuest"
                            oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');"
                            icon-pack="feather" v-validate="'numeric'" data-vv-as="Auto Submission Days" icon-after
                            v-model="config.benfSubQuestBriefDays" /> day(s) for auto submission of cases from
                            Petitioner/Sponsor.</p>
                        </div>
                    </div>
                    <div class="vx-col w-full"
                        v-if="(this.getUserRoleId == 3 && this.getTenantTypeId == 2) || this.getUserRoleId == 50">

                        <div class="form_group">

                            <p>Remind to update profile information for every <vs-input :key="'remindPtnrInfoUpdateDays'"
                                    oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');"
                                    class="textfiled" name="remindPtnrInfoUpdateDays" icon-pack="feather"
                                    v-validate="'numeric'" data-vv-as="Case default deadline days" icon-after
                                    v-model="config.remindPtnrInfoUpdateDays" />day(s). </p>



                        </div>

                    </div>

                    <div class="vx-col w-full">

                        <div class="form_group d-flex align-center">

                            <p class="form_label nowrap mb-0"> Who will reassign case</p>



                            <multiselect data-vv-as="Default Courier" v-model="config.whoWillReassignCase"
                                :allow-empty="false" :options="allUserRoles" :multiple="true" :close-on-select="false"
                                :clear-on-select="true" :preserve-search="true" placeholder="Select" label="name"
                                track-by="name" :preselect-first="false" name="courier" :class="'w-auto multi_list_hide'">

                                <template slot="selection" slot-scope="{ values,  isOpen }">

                                    <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{
                                        values.length }} options selected</span>

                                </template>

                            </multiselect>

                            <span class="text-danger text-sm" v-show="errors.has('courier')">{{ errors.first("courier")
                            }}</span>

                        </div>

                    </div>
                    <div class="vx-col w-full">
                    <div class="form_group d-flex align-center">

                        <p class="form_label nowrap mb-0">Who can transfer their own case</p>



                        <multiselect data-vv-as="Default Courier" v-model="config.ownCaseTransferRoleIds"
                            :allow-empty="false" :options="caseTransverUserRoles" :multiple="true" :close-on-select="false"
                            :clear-on-select="true" :preserve-search="true" placeholder="Select" label="name"
                            track-by="name" :preselect-first="false" name="courier" :class="'w-auto multi_list_hide'">

                            <template slot="selection" slot-scope="{ values,  isOpen }">

                                <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{
                                    values.length }} options selected</span>

                            </template>

                        </multiselect>

                        <span class="text-danger text-sm" v-show="errors.has('courier')">{{ errors.first("courier")
                        }}</span>

                    </div>
</div>

                    <div class="vx-col w-full">

                        <div class="form_group d-flex align-center">

                            <p class="form_label nowrap mb-0"> Contact information used in G-28 Form?</p>



                            <multiselect data-vv-as="Default Courier" v-model="config.contactInfoOfG28Form"
                                :allow-empty="false" :options="contatctInfoList" :multiple="false" :close-on-select="true"
                                :clear-on-select="true" :preserve-search="true" placeholder="Select" label="name"
                                track-by="name" :preselect-first="false" name="courier" :class="'w-auto multi_list_hide'">

                                <template slot="selection" slot-scope="{ values,  isOpen }">

                                    <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{
                                        values.length }} options selected</span>

                                </template>

                            </multiselect>

                            <span class="text-danger text-sm" v-show="errors.has('courier')">{{ errors.first("courier")
                            }}</span>

                        </div>

                    </div>





                    <div class="vx-col w-full" v-if="getTenantTypeId != 2">

                        <div class="form_group custom-radio_wrap filing_fee_type">

                            <label>Filing Fee Type</label>

                            <ul class="custom-radio" vs-type="flex" vs-align="center">

                                <li>





                                    <vs-radio name="manual_entry" vs-value="manual_entry"
                                        v-model="config.filingFeeCategoryType" class="w-full"><span
                                            ref="manual_entry">Manual Entry</span></vs-radio>





                                </li>

                                <li>



                                    <vs-radio ref="pre_defined" name="manual_entry" vs-value="pre_defined"
                                        v-model="config.filingFeeCategoryType" class="w-full"> <span ref="pre_defined">Pre
                                            Defined</span></vs-radio>



                                </li>



                            </ul>

                        </div>

                    </div>

                    <div class="vx-col w-full" v-if="getTenantTypeId != 2">
                        <div class="form_group">



                            <p>Invoice Payment Terms<vs-input :key="'invoicePaymentTermsDays'"
                                    oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');"
                                    class="textfiled" name="invoicePaymentTermsDays" icon-pack="feather" v-validate="'numeric'"
                                    data-vv-as="Case default deadline days" icon-after
                                    v-model="config.invoicePaymentTermsDays" /> days.</p>



                        </div>
                    </div>







                    <div class="vx-col w-full">

                        <div class="form_group d-flex align-center">

                            <p class="form_label nowrap mb-0">Default Courier</p>



                            <multiselect data-vv-as="Default Courier" v-model="config.defaultCourierDetails"
                                :allow-empty="false" :options="masterCourierList" :multiple="true" :close-on-select="false"
                                :clear-on-select="true" :preserve-search="true" placeholder="Select" label="name"
                                track-by="name" :preselect-first="false" name="courier" :class="'w-auto multi_list_hide'">

                                <template slot="selection" slot-scope="{ values,  isOpen }">

                                    <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{
                                        values.length }} options selected</span>

                                </template>

                            </multiselect>

                            <span class="text-danger text-sm" v-show="errors.has('courier')">{{ errors.first("courier")
                            }}</span>

                        </div>

                    </div>











                    <div class="vx-col w-full">

                        <div class="form_group d-flex align-center">

                            <p class="form_label nowrap mb-0">Timezone</p>

                            <!-----Impliment Time zone Select box   v-model="config.tenantDefaultTZ"   md_timezone-->

                            <multiselect data-vv-as="Time zone" v-model="config.tenantDefaultTZ" :allow-empty="false"
                                :options="timeZoneList" :multiple="false" :close-on-select="true" :clear-on-select="false"
                                :preserve-search="true" placeholder="Select" label="name" track-by="name"
                                :preselect-first="false" name="Timezone" :class="'w-auto'">

                                <template slot="selection" slot-scope="{ values,  isOpen }">

                                    <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{
                                        values.length }} options selected</span>

                                </template>

                            </multiselect>

                            <span class="text-danger text-sm" v-show="errors.has('Timezone')">{{ errors.first("Timezone")
                            }}</span>

                        </div>

                    </div>





                    <div class="vx-col w-full mt-2">

                        <h3 class="small-header pl-0">LCA </h3>

                    </div>



                    <div class="vx-col w-full">

                        <div class="form_group d-flex align-center">

                            <p class="form_label mb-0"> Collect information of all vendors involved in contract while
                                requesting? </p>

                            <div class="table_switch mb-0 ml-4">

                                <vs-switch class="mb-0" v-model="config.allowToAddLCALayers">

                                    <span slot="on">Yes</span>

                                    <span slot="off">No</span>

                                </vs-switch>

                            </div>

                        </div>

                    </div>





                    <div class="vx-col w-full">

                        <div class="form_group d-flex align-center">

                            <p class="form_label mb-0"> Accept Entity/Home type for Work Location.</p>

                            <div class="table_switch mb-0 ml-4">

                                <vs-switch class="mb-0" v-model="config.addressEntityIOrHomeForLCA">

                                    <span slot="on">Yes</span>

                                    <span slot="off">No</span>

                                </vs-switch>

                            </div>

                        </div>

                    </div>

                    <div class="vx-col w-full">

                        <div class="form_group d-flex align-center">

                            <p class="form_label mb-0"> Accept multiple Job Duties. </p>

                            <div class="table_switch mb-0 ml-4">

                                <vs-switch class="mb-0" v-model="config.multipleJobDutiesForLCA">

                                    <span slot="on">Yes</span>

                                    <span slot="off">No</span>

                                </vs-switch>

                            </div>

                        </div>

                    </div>

                    <!---preSOCCodeMandatoryLCA-->

                    <div class="vx-col w-full">

                        <div class="form_group d-flex align-center">

                            <p class="form_label mb-0"> Is preferred SOC code mandatory while requesting? </p>

                            <div class="table_switch mb-0 ml-4">

                                <vs-switch class="mb-0" v-model="config.preSOCCodeMandatoryLCA">

                                    <span slot="on">Yes</span>

                                    <span slot="off">No</span>

                                </vs-switch>

                            </div>

                        </div>

                    </div>



                    <div class="vx-col w-full">

                        <div class="form_group d-flex align-center">

                            <p class="form_label mb-0"> Accept multiple Educational information. </p>

                            <div class="table_switch mb-0 ml-4">

                                <vs-switch class="mb-0" v-model="config.multiEduDetailsForLCA">

                                    <span slot="on">Yes</span>

                                    <span slot="off">No</span>

                                </vs-switch>

                            </div>

                        </div>

                    </div>



                    <div class="vx-col w-full">

                        <div class="form_group d-flex align-center">

                            <p class="form_label mb-0"> Collect Years of Experience information </p>

                            <div class="table_switch mb-0 ml-4">

                                <vs-switch class="mb-0" v-model="config.yearsOfExpRequiredForLCA">

                                    <span slot="on">Yes</span>

                                    <span slot="off">No</span>

                                </vs-switch>

                            </div>

                        </div>

                    </div>



                    <div class="vx-col w-full mt-10 mb-4">

                        <h3 class="block-header">PERM Settings</h3>

                    </div>

                    <!---advCoolingPeriod--->

                    <div class="vx-col w-full">

                        <div class="form_group">

                            <p>Consider <vs-input :key="'advCoolingPeriod'"
                                    oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');"
                                    class="textfiled" name="advCoolingPeriod" icon-pack="feather" v-validate="'numeric'"
                                    data-vv-as="Advertisement Cooling Period days" icon-after
                                    v-model="config.advCoolingPeriod" /> days as Advertisement Cooling Period (between the
                                last advertisement and PERM filing date).</p>



                        </div>

                    </div>

                    <!----advMinDuration-->

                    <div class="vx-col w-full">

                        <div class="form_group">

                            <p>Have <vs-input :key="'advMinDuration'"
                                    oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');"
                                    class="textfiled" name="advMinDuration" icon-pack="feather" v-validate="'numeric'"
                                    data-vv-as="Advertisement between advertisements start and end dates" icon-after
                                    v-model="config.advMinDuration" /> days between advertisements start and end dates. </p>



                        </div>

                    </div>

                    <div class="vx-col w-full">

                        <div class="form_group">

                            <p>PERM to be filed within <vs-input :key="'permFileDaysAfterLastAdv'"
                                    oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');"
                                    class="textfiled" name="permFileDaysAfterLastAdv" icon-pack="feather"
                                    v-validate="'numeric'"
                                    data-vv-as="first advertisement released or before PWD Expiry Date" icon-after
                                    v-model="config.permFileDaysAfterLastAdv" />days of first advertisement released or
                                before PWD Expiry Date. </p>



                        </div>

                    </div>



                    <div class="vx-col w-full">

                        <div class="form_group d-flex align-center">

                            <p class="form_label nowrap mb-0"> PWD Default Activity Users</p>



                            <multiselect data-vv-as="Default Courier" v-model="config.handlePwdActivityUsers"
                                :allow-empty="false" :options="allUserRoles" :multiple="true" :close-on-select="false"
                                :clear-on-select="true" :preserve-search="true" placeholder="Select" label="name"
                                track-by="name" :preselect-first="false" name="courier" :class="'w-auto multi_list_hide'">

                                <template slot="selection" slot-scope="{ values,  isOpen }">

                                    <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{
                                        values.length }} options selected</span>

                                </template>

                            </multiselect>

                            <span class="text-danger text-sm" v-show="errors.has('courier')">{{ errors.first("courier")
                            }}</span>

                        </div>

                    </div>
                    <div class="vx-col w-full" v-if="false">

                        <div class="form_group d-flex align-center">

                            <p class="form_label mb-0">Petitioner Reviewed required for PWD document </p>

                            <div class="table_switch mb-0 ml-4">

                                <vs-switch class="mb-0" v-model="config.petiApprovReqPWDDoc">

                                    <span slot="on">Yes</span>

                                    <span slot="off">No</span>

                                </vs-switch>

                            </div>

                        </div>

                    </div>
                    <template>

                    <div class="vx-col w-full mt-10 mb-4">

                        <h3 class="block-header">Cap Registrations</h3>

                    </div>

<!----manageCapRegistrations-->

                <div class="vx-col w-full">



                    <div class="form_group d-flex align-center">

                        <p class="form_label mb-0">Allow to add CAP Registrations? </p>

                        <div class="table_switch mb-0 ml-4">

                            <vs-switch class="mb-0" v-model="config.manageCapRegistrations">

                                <span slot="on">Yes</span>

                                <span slot="off">No</span>

                            </vs-switch>

                        </div>

                    </div>

                </div>



<!---- currentSeasonYear 

this.allSesasonsList-->

            <div class="vx-col w-full">

                <div class="form_group d-flex align-center">

                    <p class="form_label nowrap mb-0">Current CAP Season Year</p>



                    <multiselect v-model="config.currentSeasonYear" :allow-empty="false"
                        :options="allSesasonsList" :multiple="false" :close-on-select="true"
                        :clear-on-select="true" :preserve-search="true" placeholder="Select"
                        v-validate="'required'" data-vv-as="Please select Season" label="name"
                        track-by="name" :preselect-first="false" name="currentSeasonYear"
                        :class="'w-auto multi_list_hide'">

                        <template slot="selection" slot-scope="{ values,  isOpen }">

                            <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{
                                values.length }} options selected</span>

                        </template>

                    </multiselect>

                    <span class="text-danger text-sm" v-show="errors.has('currentSeasonYear')">{{
                        errors.first("currentSeasonYear") }}</span>

                </div>



            </div>

            <div class="vx-col w-full">

                <div class="form_group d-flex align-center">

                    <p class="form_label mb-0"> All internal users can view all CAP Registrations</p>

                    <div class="table_switch mb-0 ml-4">

                        <vs-switch class="mb-0" v-model="config.canInternalUsersSeeAllCapCases">

                            <span slot="on">Yes</span>

                            <span slot="off">No</span>

                        </vs-switch>

                    </div>

                </div>

            </div>

            <!-- {{ config.whoCanPerformAllCapActions }} -->

            <div class="vx-col w-full">

                <div class="form_group d-flex align-center">

                    <p class="form_label nowrap mb-0"> Who can perform CAP Registrations actions</p>

                    <multiselect data-vv-as="Default Courier" v-model="config.whoCanPerformAllCapActions"
                        :allow-empty="true" :options="capActionRoles" :multiple="true"
                        :close-on-select="false" :clear-on-select="true" :preserve-search="true"
                        placeholder="Select" label="name" track-by="name" :preselect-first="false"
                        name="courier" :class="'w-auto multi_list_hide'">

                        <template slot="selection" slot-scope="{ values,  isOpen }">

                            <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{
                                values.length }} options selected</span>

                        </template>

                    </multiselect>

                    <span class="text-danger text-sm" v-show="errors.has('courier')">{{
                        errors.first("courier") }}</span>

                </div>

            </div>
            <div class="vx-col w-full">               
                                    <div class="form_group d-flex align-center">
                                        <p class="form_label mb-0"> Disable H-1B CAP Registrations for Petitioner?</p>
                                        <div class="table_switch mb-0 ml-4">                    
                                            <vs-switch class="mb-0"  v-model="config.disableH1bCapRegForPetitioner">
                                                <span slot="on">Yes</span>
                                                <span slot="off">No</span>
                                            </vs-switch>
                                        </div>
                                    </div>                
            </div>

    </template>
</template>
                <div class="vx-col w-100">

                    <div class="popup-footer form-footer form-footer2 height-auto mb-4">

                        <vs-button color="success" class="save" :disabled="configSaving" @click="updateQconfig"
                            type="filled">

                            <template v-if="checkProperty(this.configDetails, '_id')">Update</template>

                            <template v-else>Save</template>

                        </vs-button>

                    </div>

                </div>
            </div>
        </div>
        <!-- <div class="popup-footer form-footer"> 
        <vs-button color="success" class="save" :disabled="configSaving" @click="updateQconfig" type="filled"> 

         <template v-if="checkProperty(this.configDetails ,'_id'  )">Update</template> 

         <template v-else>Save</template> 
        </vs-button> 

    </div> -->
    <Modal
  name="showMfaConformModal"
  classes="v-modal-sec"
  :min-width="200"
  :min-height="200"
  :scrollable="true"
  :reset="true"
  width="450px"
  height="auto"
>
  <div class="v-modal">
    <div class="popup-header fromDetailsPage">
      <h2 class="popup-title">Confirmation</h2>
      <span @click="hideConfirmation">
        <em class="material-icons">close</em>
      </span>
    </div>

    <div class="form-container">
      <div class="vx-row">
        <div class="vx-col w-full">
          <p class="msg_text1">Please note that the Multi-Factor Authentication is an additional layer of security to users' account. Disabling this will impact the account security to a greater extent. If you proceed, Multi-Factor Authentication will be disabled for all impacted user groups.</p>
        </div>
      </div>
    </div>

    <div class="popup-footer relative">
      <vs-button
        color="dark"
        class="cancel"
        type="filled"
        @click="hideConfirmation"
      >
        Cancel
      </vs-button>
      <vs-button
        color="success"
        class="save"
        type="filled"
        @click="proceedAction"
      >
        Proceed
      </vs-button>
    </div>
  </div>
    </Modal>

    </form>
    
</template> 
<script>

import DateRangePicker from "vue2-daterange-picker";

import Paginate from "vuejs-paginate";

import Datepicker from "vuejs-datepicker-inv";

import Multiselect from "vue-multiselect-inv";

import JQuery from "jquery";

import selectField from "@/views/forms/fields/simpleselect.vue";

import datepickerField from "@/views/forms/fields/datepicker.vue";

import immiInput from "@/views/forms/fields/simpleinput.vue";

import moment from "moment"

import _ from "lodash";

import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import { mapActions } from 'vuex';
import { Modal } from "@amcharts/amcharts4/core";

export default {

    provide() {

        return {

            parentValidator: this.$validator,

        };

    },

    props: {

        branchId: {

            type: String,

            default: ''

        }

    },

    components: {

        immiInput,

        datepickerField,

        selectField,

        Datepicker,

        DateRangePicker,

        Multiselect,

        Paginate,

    },

    data: () => ({
        showMfaError:false,
        showAddseasonsPopup: false,

        seletedObj: {

            effectiveDate: null,

            seasonYear: null,

        },

        seasonsYears: [],

        capSeasonEffectiveList: [],

        allSesasonsList: [],

        allUserRoles: [],
        caseTransverUserRoles:[],
        capActionRoles: [],

        masterCourierList: [],

        configSaving: false,

        contatctInfoList: [

            { id: 'law_firm', 'name': 'Law Firm' },

            { id: 'attorney', 'name': 'Attorney' }

        ],

        config: {
            mfaRequired:false,
            mfaConfig: {
                gracePeriodInDays: null, 
                enableTo: []
            },
            enableI9Requests:false,
            acceptConsentAndTAndC:false,
            enablePAFRequests:false,
            currentSeasonYear: '',
            manageCapRegistrations: false,
            remindPtnrInfoUpdateDays: null,
            'ptnrBriefDays': null,
            benfSubQuestBriefDays: null,
            allowCustonCaseNo: false,
            showCaseDeadLineDateforPetitioner:false,
            "prefillCountryInQuestionnaire": false,
            //   "isI94DSExpiryDate":false, 
            "usePtnrAddrAsMailingAddrInUSCISForms": false,
            acceptCompayDocsForPtnr: false,
            isAllowExternalCases: false,
            requiredPinForQuesSubmit: false,
            //petiApprovReqPWDDoc: false,
            procefilPERMCoolNotMet: false,

            "isPtnrActAsUSCISFormsPreparer": false,

            allowToAddLCALayers: false,

            "addressEntityIOrHomeForLCA": false, // Send for Entity/Home Address 

            "multipleJobDutiesForLCA": false,

            "multiEduDetailsForLCA": false, // Send for multiple education details 

            "defaultCourierIds": null,

            defaultCourierDetails: [],

            "filingFeeCategoryType": 'manual_entry',  //false =="manual_entry" , true="pre_defined" 

            "ptnrAttorneySignByInternal": false,

            "preSOCCodeMandatoryLCA": false,

            yearsOfExpRequiredForLCA: false,

            canInternalUsersSeeAllCapCases: false,

            taskApprovalRequired: false,

            commuEmails: '',
            
            disableH1bCapRegForPetitioner:false,

            "caseDeadlineDays": null,

            rfeCaseDeadlineDays: null,
            invoicePaymentTermsDays:null,

            "priorI94DeadlineDays": null,

            advCoolingPeriod: 30,

            advMinDuration: 30,

            priorFormsEffectiveDays: null,

            tenantDefaultTZ: "",

            requiredQBForInvoice: false,
            showCustomReports:false,

            permFileDaysAfterLastAdv: null,

            handlePwdActivityUsers: [],

            whoCanPerformAllCapActions: [],

            whoWillReassignCase: [],
            ownCaseTransferRoleIds:[],

            contactInfoOfG28Form: null,

            // caseSeleByUscisInLotteryDays: null, 

            // priorToExpiryDaysH1b: null, 

            // lcaSubAndQuestNotSubBriefDays: null, 

            // pwdCertOrBeforeExpiryDays: null, 

            // lastAdvReleaseBriefDays: null, 

            // priorToExpiryPermDays: null, 

            // i140ApprovedDuringDays: null, 

            // gcEmpi485ApprovedDays: null, 

            // i130ApprovedDuringDays: null, 

            // gcfamilyi485ApprovedDays: null, 

            // priorToExpiryl1aOrl1b: null, 

            // l1i140ApprovedDuringDays: null, 

            reminders: {

                pwdExpiry: {

                    config: [

                        {

                            days: ''

                        },

                    ]

                },

                i140: {

                    config: [

                        {

                            days: ''

                        },

                    ]

                },

                sponQuestionnire: {

                    config: [

                        {

                            days: ''

                        },

                    ]

                },

                caseSeleByUscisInLotteryDays: {

                    whoWillSendReminder: [],

                    config: [



                        {

                            days: ''

                        },

                    ]

                }

                ,

                priorToExpiryDaysH1b: {

                    whoWillSendReminder: [],

                    config: [



                        {

                            days: ''

                        },

                    ]

                },

                lcaSubAndQuestNotSubBriefDays: {

                    whoWillSendReminder: [],

                    config: [



                        {

                            days: ''

                        },

                    ]

                },

                pwdCertOrBeforeExpiryDays: {

                    whoWillSendReminder: [],

                    config: [



                        {

                            days: ''

                        },

                    ]

                },

                lastAdvReleaseBriefDays: {

                    whoWillSendReminder: [],

                    config: [



                        {

                            days: ''

                        },

                    ]

                },

                priorToExpiryPermDays: {

                    whoWillSendReminder: [],

                    config: [



                        {

                            days: ''

                        },

                    ]

                },

                i140ApprovedDuringDays: {

                    whoWillSendReminder: [],

                    config: [



                        {

                            days: ''

                        },

                    ]

                },

                gcEmpi485ApprovedDays: {

                    whoWillSendReminder: [],

                    config: [



                        {

                            days: ''

                        },

                    ]

                },

                i130ApprovedDuringDays: {

                    whoWillSendReminder: [],

                    config: [



                        {

                            days: ''

                        },

                    ]

                },

                gcfamilyi485ApprovedDays: {

                    whoWillSendReminder: [],

                    config: [



                        {

                            days: ''

                        },

                    ]

                },

                priorToExpiryl1aOrl1b: {

                    whoWillSendReminder: [],

                    config: [



                        {

                            days: ''

                        },

                    ]

                },

                l1i140ApprovedDuringDays: {

                    whoWillSendReminder: [],

                    config: [



                        {

                            days: ''

                        },

                    ]

                }

            }



        },

        configDetails: null,

        SubmtRminder: false,

        linkShareToEmailList: [],

        timeZoneList: [],

        seasonnYearError: '',

    }),

    watch: {
        // 'config.mfaRequired'(newValue) {
        //     if (!newValue) {
        //     this.config.mfaConfig.gracePeriodInDays = null;
        //     if(this.checkProperty(this.config['mfaConfig'], 'enableTo','length') > 0){
        //         this.config.mfaConfig.enableTo.forEach(user => {
        //         user.enable = false;
        //     });
        //     }
           
        //     }
        // }
    },

    methods: {
        ...mapActions(['commonAction', 'incrementUpdateSideMenu']),
        deleteSeason(val) {

            if (this.checkProperty(this.capSeasonEffectiveList, 'length') > 0) {

                let seasonFiltered = _.filter(this.capSeasonEffectiveList, (item) => {

                    if (item['seasonYear'] != val['seasonYear']) {

                        return item

                    }

                });

                this.capSeasonEffectiveList = _.cloneDeep(seasonFiltered);

                // this.seasonsYears.push(val['seasonYear']); 

                // let list = _.cloneDeep(this.seasonsYears); 

                // list.sort(function(a, b) { 

                //     return a - b; 

                // }); 

                // if(this.checkProperty(list, 'length')>0){ 

                //     this.seasonsYears = _.cloneDeep(list) 

                // } 

            }

        },
        conformMaf() {
        if (this.config&&this.config.mfaRequired) {
            if (this.checkProperty(this.config['mfaConfig'], 'enableTo', 'length') > 0) {
                let isAnyUserEnabled = this.config.mfaConfig.enableTo.find(user => user.enable);
                if (isAnyUserEnabled&&this.config.mfaConfig&&this.config.mfaConfig.gracePeriodInDays) {
                    this.$modal.show('showMfaConformModal');
                }
                if (this.config&&this.config.mfaConfig&&this.config.mfaConfig.gracePeriodInDays) {
                    this.$modal.show('showMfaConformModal');
                }
                if (isAnyUserEnabled) {
                    this.$modal.show('showMfaConformModal');
                }
            }
        } 
    },
   checkValidation() {
    this.showMfaError = false
   },
    proceedAction() {
        this.config.mfaRequired = false
        this.config.mfaConfig.gracePeriodInDays = null;
        if(this.checkProperty(this.config['mfaConfig'], 'enableTo','length') > 0){
            this.config.mfaConfig.enableTo.forEach(user => {
                user.enable = false;
            });
        }
        this.$modal.hide('showMfaConformModal');
    },
    hideConfirmation(){
        this.config.mfaRequired = true
        this.$modal.hide('showMfaConformModal')
    },

        addSeasonstoList() {

            this.$validator.validateAll('showAddseasonsPopup').then((result) => {

                if (result) {

                    this.seasonnYearError = '';

                    if (this.checkProperty(this.capSeasonEffectiveList, 'length') > 0) {

                        let findobj = _.find(this.capSeasonEffectiveList, { 'seasonYear': this.seletedObj['seasonYear'] });

                        if (findobj) {

                            this.seasonnYearError = 'Season year already exists'

                        }

                        if (!findobj) {

                            this.capSeasonEffectiveList.push(this.seletedObj);

                            // let seasonFiltered = _.filter(this.seasonsYears,(it)=>{ 

                            //     return it != this.seletedObj['seasonYear']; 

                            // }); 

                            // if(seasonFiltered){ 

                            //     this.seasonsYears = _.cloneDeep(seasonFiltered) 

                            // } 

                            this.addSeasonYears(false)

                        }

                    } else {

                        this.capSeasonEffectiveList.push(this.seletedObj);

                        // let seasonFiltered = _.filter(this.seasonsYears,(it)=>{ 

                        //     return it != this.seletedObj['seasonYear']; 

                        // }); 

                        // if(seasonFiltered){ 

                        //     this.seasonsYears = _.cloneDeep(seasonFiltered) 

                        // } 

                        this.addSeasonYears(false)

                    }



                }

            })

        },

        addSeasonYears(open = false) {

            this.$validator.reset();

            this.seletedObj = {

                seasonYear: null,

                effectiveDate: null,

            }

            this.seasonnYearError = '';

            if (open) {

                this.showAddseasonsPopup = true;

            } else {

                this.showAddseasonsPopup = false;

            }

        },

        getGraduatedYears() {

            this.seasonsYears = [];

            let currentYear = 2023;

            let futureYear = parseInt(currentYear) + 100

            for (let i = currentYear; i <= futureYear; i += 1) {

                //let item = {'id':i,'name':i} 

                this.seasonsYears.push(i)

            }

        },

        getAllSeasonsList() {

            this.allSesasonsList = [];

            this.capSeasonEffectiveList = [];

            this.$store.dispatch("getList", {

                data: { today: moment().format('YYYY-MM-DD') },

                path: "/cap-registrations/get-season-year-list",

            })

                .then((response) => {

                    if (response && this.checkProperty(response, 'length') > 0) {

                        _.forEach(response, (obj) => {

                            let seasonYear = { "name": obj, 'id': obj, }

                            this.allSesasonsList.push(seasonYear);

                            //this.allSesasonsList = this.checkProperty(response,'list'); 

                        });



                    }

                });

        },

        getUserRoles() {

            let postData = {

                page: 1,

                perpage: 10000,

                category: "user_roles",

                // tenantId: "5db7d79d6032453bd060ed9c", 

            }



            this.$store.dispatch("getMasterData", postData).then(response => {

                this.allUserRoles = response.list;
                //this.caseTransverUserRoles=response.list;
                this.allUserRoles = _.filter(this.allUserRoles, (rol) => {

                    return [1, 2].indexOf(rol['id']) <= -1

                })
                this.caseTransverUserRoles = _.filter(this.allUserRoles, (rol) => {

                  return [6,7,8,9,10].indexOf(rol['id']) > -1

              })
                this.capActionRoles = _.filter(response.list, (rol) => {

                    return [1, 2, 50, 51].indexOf(rol['id']) <= -1

                })

                this.processHandlePwdActivityUsers();

                this.processHandlecapHandlers();



            })

        },

        getCourierList() {



            let postdata = {};

            this.$store

                .dispatch("getList", { data: postdata, path: "/tracking/courierlist" }).then((response) => {

                    if (this.checkProperty(response, "list")) {

                        this.masterCourierList = response['list'];

                    }

                    //this.optionCourierList = response; 

                    if (_.has(this.configDetails, "config.defaultCourierIds")) {

                        this.config['defaultCourierIds'] = this.configDetails['config']['defaultCourierIds'];

                        if (this.checkProperty(this.masterCourierList, 'length') > 0) {

                            this.config['defaultCourierDetails'] = _.filter(this.masterCourierList, (item) => {

                                return this.config['defaultCourierIds'].indexOf(item['id']) > -1

                            })



                        }

                    }



                });



        },

        checkInputValue(item, index) {

            item['showError'] = false;

            this.config['reminders']['pwdExpiry']['config'][index]['showError'] = false;

            let pitem = this.config['reminders']['pwdExpiry']['config'][index - 1];

            if (_.get(pitem, 'days')) {

                let pdays = _.get(pitem, 'days')

                let maxValue = parseInt(pdays) - 1;

                if (maxValue > 0) {

                    if (parseInt(item['days']) > parseInt(maxValue)) {

                        item['days'] = null;

                        item['showError'] = true;

                    }

                }

            }

        },

        checkInputI140Value(item, index, category) {

            item['showError'] = false;

            this.config['reminders'][category]['config'][index]['showError'] = false;

            let pitem = this.config['reminders'][category]['config'][index - 1];

            if (_.get(pitem, 'days')) {

                let pdays = _.get(pitem, 'days')

                let minValue = parseInt(pdays) + 1;

                if (minValue > 0) {

                    if (parseInt(item['days']) < parseInt(minValue)) {

                        item['days'] = null;

                        item['showError'] = true;

                    }

                }

            }

        },

        removefilingfee: function (category, index) {

            this.config['reminders'][category]['config'].splice(index, 1);

        },

        addMoreKeys(category) {

            this.$validator.validateAll(category).then((result) => {

                if (result) {

                    this.config['reminders'][category]['config'].push(

                        {

                            days: '',

                            showError: false,

                        },

                    );

                }

            });



        },

        formatEmail(assignValue = false) {



            // linkShareToemailsText:'', 

            // sharing:false, 

            let emailList = this.config['commuEmails'].split(',');

            this.linkShareToEmailList = [];

            let tempEmailList = [];

            if (this.checkProperty(emailList, 'length') > 0) {

                const validateEmail = (email) => {

                    return String(email)

                        .toLowerCase()

                        .match(

                            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

                        );

                };



                this.linkShareToEmailList = _.filter(emailList, (email) => {

                    if (validateEmail(email)) {

                        return true;

                    } else {

                        return false;

                    }



                })

                if (assignValue) {

                    this.config['commuEmails'] = this.linkShareToEmailList.join(',');

                }





                // alert(JSON.stringify(this.linkShareToEmailList)); 





            }



        },

        updateQconfig() {

            this.formatEmail(true);

            this.$validator.validateAll('pwdExpiry')

            this.$validator.validateAll('i140')

            this.$validator.validateAll('sponQuestionnire')





            this.$validator.validateAll('pwdExpiry').then((result) => {

                if (result) {

                    this.$validator.validateAll('mfaAuthentication').then((result) => {
                        if (this.checkProperty(this.config['mfaConfig'], 'enableTo', 'length') > 0) {
                                let isAnyUserEnabled = this.config.mfaConfig.enableTo.find(user => user.enable);
                                if (!isAnyUserEnabled&&this.checkProperty(this.config,'mfaRequired')!=false) {
                                    this.showMfaError = true;
                                    this.scrollWIndow(); 
                                    return; 
                                } else {
                                    this.showMfaError = false; 
                                }
                        }
                        if (result) {
                            this.$validator.validateAll('sponQuestionnire').then((result) => {

                                if (result) {

                                    let path = "/global-config/create"

                                    if (this.checkProperty(this.configDetails, "_id")) {

                                        path = "/global-config/update"

                                    }

                                    let self = this;

                                    let config = _.cloneDeep(self.config);

                                    config['ptnrBriefDays'] = parseInt(config.ptnrBriefDays);

                                    if (parseInt(config.ptnrBriefDays) <= 0) {

                                        config['ptnrBriefDays'] = null

                                    }

                                    config['benfSubQuestBriefDays'] = parseInt(config.benfSubQuestBriefDays);

                                    if (parseInt(config.benfSubQuestBriefDays) <= 0) {

                                        config['benfSubQuestBriefDays'] = null

                                    }

                                    if (this.linkShareToEmailList.length > 0) {

                                        config['commuEmails'] = this.linkShareToEmailList.join(',')

                                    }



                                    if (!this.checkProperty(self.config, "advCoolingPeriod")) {

                                        self.config['advCoolingPeriod'] = 0;

                                    }

                                    if (!this.checkProperty(self.config, "advMinDuration")) {

                                        self.config['advMinDuration'] = 0;

                                    } else if (this.checkProperty(self.config, "advMinDuration") > 0) {

                                        self.config['advMinDuration'] = parseInt(self.config.advMinDuration);

                                    } 



                                    if (this.checkProperty(self.config, "rfeCaseDeadlineDays") > 0) {

                                        self.config['rfeCaseDeadlineDays'] = parseInt(self.config.rfeCaseDeadlineDays);

                                    }
                                    if (this.checkProperty(self.config, "invoicePaymentTermsDays") > 0) {

                                        self.config['invoicePaymentTermsDays'] = parseInt(self.config.invoicePaymentTermsDays);

                                    }











                                    this.configSaving = true;

                                    let postData = {

                                        "config": self.config

                                    }



                                    if (this.checkProperty(self.config, "currentSeasonYear", 'name')) {

                                        postData['config']['currentSeasonYear'] = self.config['currentSeasonYear']['name'];

                                    }



                                    if (_.has(postData.config['tenantDefaultTZ'], 'id')) {

                                        postData.config['tenantDefaultTZ'] = postData.config['tenantDefaultTZ']['id']

                                    }







                                    if (this.checkProperty(this.config, 'defaultCourierDetails', 'length') > 0) {

                                        postData.config['defaultCourierIds'] = _.map(this.config['defaultCourierDetails'], (item) => item.id) //this.checkProperty(this.config ,'defaultCourierDetails' ,'id') 

                                    }



                                    //handlePwdActivityUsers    

                                    if (this.checkProperty(this.config, 'handlePwdActivityUsers', 'length') > 0) {

                                        postData.config['handlePwdActivityUsers'] = _.map(this.config['handlePwdActivityUsers'], (item) => item.id)

                                    }

                                    if (this.checkProperty(this.config, 'whoCanPerformAllCapActions', 'length') > 0) {

                                        postData.config['whoCanPerformAllCapActions'] = _.map(this.config['whoCanPerformAllCapActions'], (item) => item.id)

                                    }

                                    if (this.checkProperty(this.config, 'whoWillReassignCase', 'length') > 0) {

                                        postData.config['whoWillReassignCase'] = _.map(this.config['whoWillReassignCase'], (item) => item.id)

                                    }
                                    if (this.checkProperty(this.config, 'ownCaseTransferRoleIds', 'length') > 0) {
                                        postData.config['ownCaseTransferRoleIds'] = _.map(this.config['ownCaseTransferRoleIds'], (item) => item.id)
                                        }

                                    if (this.checkProperty(this.config, 'contactInfoOfG28Form') && this.checkProperty(this.config, 'contactInfoOfG28Form', 'id')) {

                                        postData.config['contactInfoOfG28Form'] = this.checkProperty(this.config, 'contactInfoOfG28Form', 'id')

                                    }

                                    //capSeasonConfig 
                                    if ([1].indexOf(this.getUserRoleId) > -1) {
                                        postData['config']['capSeasonConfig'] = this.capSeasonEffectiveList
                                    }
                                    this.$store.dispatch("commonAction", { data: postData, path: path })
                                        .then((response) => {
                                           this.$store.dispatch('incrementUpdateSideMenu');
                                            this.configSaving = false;
                                            this.updateExternalCase(postData['config']['isAllowExternalCases'])
                                            this.showToster({ message: response.message, isError: false });
                                            this.getGlobalConfigDetails();
                                        })
                                        .catch((error) => {
                                            this.configSaving = false;
                                            this.showToster({ message: error, isError: true });
                                        });

                                }

                            })

                        }else {
                          this.scrollWIndow();
                        }

                    })

                }

            })



        },
        scrollWIndow() {
        const $ = JQuery;

      $("html, body").animate(
        {
          scrollTop: $(".text-danger").first().offset().top,
        },
        2000
      );
    },

        updateExternalCase(action = false) {

            this.$store.commit('updateExternalCases', action);

        },

        ///global-config/details 

        getGlobalConfigDetails() {

            let postData = {}

            //  this.configDetails =null 

            let path = 'global-config/details'

            this.$store.dispatch("commonAction", { data: postData, path: path })

                .then((response) => {

                    this.configDetails = response;



                    if ([1].indexOf(this.getUserRoleId) > -1) {

                        if (this.checkProperty(this.configDetails, "config", "capSeasonConfig") && this.checkProperty(this.configDetails['config'], 'capSeasonConfig', 'length') > 0) {

                            this.capSeasonEffectiveList = this.checkProperty(this.configDetails, "config", "capSeasonConfig");

                            if (this.capSeasonEffectiveList && this.checkProperty(this.capSeasonEffectiveList, 'length') > 0 && false) {

                                let list = this.capSeasonEffectiveList;

                                let yearArrayList = [];

                                _.forEach(list, (yr) => {

                                    if (_.has(yr, 'seasonYear')) {

                                        let it = parseInt(yr['seasonYear'])

                                        yearArrayList.push(it);

                                    }

                                });

                                if (this.checkProperty(yearArrayList, 'length') > 0 && this.checkProperty(this.seasonsYears, 'length') > 0) {

                                    let seasonsFiltered = this.seasonsYears.filter(element => !yearArrayList.includes(element));

                                    this.seasonsYears = _.cloneDeep(seasonsFiltered);

                                }

                            }

                        }

                    }



                    if (_.has(this.configDetails, "config.manageCapRegistrations")) {

                        this.config['manageCapRegistrations'] = this.configDetails['config']['manageCapRegistrations'];

                        this.$store.commit('updateManageCapRegistrations', this.config['manageCapRegistrations']);

                    } else {

                        this.$store.commit('updateManageCapRegistrations', false);

                    }



                    if (this.checkProperty(this.configDetails, "config", "currentSeasonYear")) {

                        let year = this.checkProperty(this.configDetails, "config", "currentSeasonYear");

                        let currentSeasonYear = { "name": year, 'id': year };

                        this.config['currentSeasonYear'] = currentSeasonYear

                    }

                    if (this.checkProperty(this.configDetails, "config", "ptnrBriefDays")) {

                        this.config['ptnrBriefDays'] = this.checkProperty(this.configDetails, "config", "ptnrBriefDays");

                    }
                    if (this.checkProperty(this.configDetails, 'config', 'ownCaseTransferRoleIds') && this.checkProperty(this.configDetails['config'], 'ownCaseTransferRoleIds', 'length') > 0) {

                        this.config['ownCaseTransferRoleIds'] = _.filter(this.allUserRoles, (rol) => {

                            return this.configDetails['config']['ownCaseTransferRoleIds'].indexOf(rol['id']) > -1

                        })



                        }

                    if (this.checkProperty(this.configDetails, "config", "benfSubQuestBriefDays")) {

                        this.config['benfSubQuestBriefDays'] = this.checkProperty(this.configDetails, "config", "benfSubQuestBriefDays");

                    }

                    //    if(this.checkProperty(this.configDetails ,"config" ,"caseSeleByUscisInLotteryDays" )){ 

                    //        this.config['caseSeleByUscisInLotteryDays'] = this.checkProperty(this.configDetails ,"config" ,"caseSeleByUscisInLotteryDays" ); 

                    //    } 

                    //    if(this.checkProperty(this.configDetails ,"config" ,"priorToExpiryDaysH1b" )){ 

                    //        this.config['priorToExpiryDaysH1b'] = this.checkProperty(this.configDetails ,"config" ,"priorToExpiryDaysH1b" ); 

                    //    } 

                    //    if(this.checkProperty(this.configDetails ,"config" ,"lcaSubAndQuestNotSubBriefDays" )){ 

                    //        this.config['lcaSubAndQuestNotSubBriefDays'] = this.checkProperty(this.configDetails ,"config" ,"lcaSubAndQuestNotSubBriefDays" ); 

                    //    } 

                    //    if(this.checkProperty(this.configDetails ,"config" ,"pwdCertOrBeforeExpiryDays" )){ 

                    //        this.config['pwdCertOrBeforeExpiryDays'] = this.checkProperty(this.configDetails ,"config" ,"pwdCertOrBeforeExpiryDays" ); 

                    //    } 

                    //    if(this.checkProperty(this.configDetails ,"config" ,"lastAdvReleaseBriefDays" )){ 

                    //        this.config['lastAdvReleaseBriefDays'] = this.checkProperty(this.configDetails ,"config" ,"lastAdvReleaseBriefDays" ); 

                    //    } 

                    //    if(this.checkProperty(this.configDetails ,"config" ,"priorToExpiryPermDays" )){ 

                    //        this.config['priorToExpiryPermDays'] = this.checkProperty(this.configDetails ,"config" ,"priorToExpiryPermDays" ); 

                    //    } 

                    //    if(this.checkProperty(this.configDetails ,"config" ,"i140ApprovedDuringDays" )){ 

                    //        this.config['i140ApprovedDuringDays'] = this.checkProperty(this.configDetails ,"config" ,"i140ApprovedDuringDays" ); 

                    //    } 

                    //    if(this.checkProperty(this.configDetails ,"config" ,"gcEmpi485ApprovedDays" )){ 

                    //        this.config['gcEmpi485ApprovedDays'] = this.checkProperty(this.configDetails ,"config" ,"gcEmpi485ApprovedDays" ); 

                    //    } 

                    //    if(this.checkProperty(this.configDetails ,"config" ,"i130ApprovedDuringDays" )){ 

                    //        this.config['i130ApprovedDuringDays'] = this.checkProperty(this.configDetails ,"config" ,"i130ApprovedDuringDays" ); 

                    //    } 

                    //    if(this.checkProperty(this.configDetails ,"config" ,"gcfamilyi485ApprovedDays" )){ 

                    //        this.config['gcfamilyi485ApprovedDays'] = this.checkProperty(this.configDetails ,"config" ,"gcfamilyi485ApprovedDays" ); 

                    //    } 

                    //    if(this.checkProperty(this.configDetails ,"config" ,"priorToExpiryl1aOrl1b" )){ 

                    //        this.config['priorToExpiryl1aOrl1b'] = this.checkProperty(this.configDetails ,"config" ,"priorToExpiryl1aOrl1b" ); 

                    //    } 

                    //    if(this.checkProperty(this.configDetails ,"config" ,"l1i140ApprovedDuringDays" )){ 

                    //        this.config['l1i140ApprovedDuringDays'] = this.checkProperty(this.configDetails ,"config" ,"l1i140ApprovedDuringDays" ); 

                    //    } 
                    if (_.has(this.configDetails, "config.enableI9Requests")) {
                        this.config['enableI9Requests'] = this.configDetails['config']['enableI9Requests'];
                    }
                    if (_.has(this.configDetails, "config.acceptConsentAndTAndC")) {
                        this.config['acceptConsentAndTAndC'] = this.configDetails['config']['acceptConsentAndTAndC'];
                    }
                //    if (_.has(this.configDetails, "config.mfaConfig")) {
                //             this.config['mfaConfig'] = this.configDetails['config']['mfaConfig'];
                //     }
               // console.log('this.configDetails',this.configDetails)
                if (this.configDetails['config'] &&this.configDetails['config']["mfaConfig"]&&this.configDetails['config']["mfaConfig"]['gracePeriodInDays']) {
                            this.config['mfaConfig']['gracePeriodInDays'] = this.configDetails['config']['mfaConfig']['gracePeriodInDays'];
                    }
                    if (this.configDetails['config']&& this.configDetails['config']["mfaConfig"]&& this.configDetails['config']["mfaConfig"]['enableTo']&& this.configDetails['config']["mfaConfig"]['enableTo']["length"]>0) {
                        console.log('this.configDetails',this.configDetails)
                            this.config['mfaConfig']['enableTo'] = this.configDetails['config']['mfaConfig']['enableTo'];
                    }
                    else{
                        console.log('this.getTenantTypeId',this.getTenantTypeId)
                        if(this.getTenantTypeId==2){
                            this.config['mfaConfig']['enableTo'] = [{
                    _id:1,
                    name: "Internal Users",
                    enable: false 
                },
                {
                    _id:3,
                    name: "Individual Customers/Beneficiaries",
                    enable: false 
                }]
                        }else{
                        this.config['mfaConfig']['enableTo'] = [{
                    _id:1,
                    name: "Internal Users",
                    enable: false 
                },
                {   _id:2,
                    name: "Corporate Customers",  
                    enable:false,
                },
                {
                    _id:3,
                    name: "Individual Customers/Beneficiaries",
                    enable: false 
                }]
            }
                    }
                    if (_.has(this.configDetails, "config.mfaRequired")) {
                        this.config['mfaRequired'] = this.configDetails['config']['mfaRequired'];
                    }
                    if (_.has(this.configDetails, "config.enablePAFRequests")) {
                        this.config['enablePAFRequests'] = this.configDetails['config']['enablePAFRequests'];
                    }
                    if (_.has(this.configDetails, "config.allowCustonCaseNo")) {

                        this.config['allowCustonCaseNo'] = this.configDetails['config']['allowCustonCaseNo'];

                    }
                    if (_.has(this.configDetails, "config.showCaseDeadLineDateforPetitioner")) {

                        this.config['showCaseDeadLineDateforPetitioner'] = this.configDetails['config']['showCaseDeadLineDateforPetitioner'];

                    }

                    if (_.has(this.configDetails, "config.usePtnrAddrAsMailingAddrInUSCISForms")) {

                        this.config['usePtnrAddrAsMailingAddrInUSCISForms'] = this.configDetails['config']['usePtnrAddrAsMailingAddrInUSCISForms'];

                    }

                    if (_.has(this.configDetails, "config.acceptCompayDocsForPtnr")) {

                        this.config['acceptCompayDocsForPtnr'] = this.configDetails['config']['acceptCompayDocsForPtnr'];

                    }

                    if (_.has(this.configDetails, "config.isAllowExternalCases")) {

                        this.config['isAllowExternalCases'] = this.configDetails['config']['isAllowExternalCases'];

                    }

                    if (_.has(this.configDetails, "config.requiredPinForQuesSubmit")) {

                        this.config['requiredPinForQuesSubmit'] = this.configDetails['config']['requiredPinForQuesSubmit'];

                    }



                    if (_.has(this.configDetails, "config.procefilPERMCoolNotMet")) {

                        this.config['procefilPERMCoolNotMet'] = this.configDetails['config']['procefilPERMCoolNotMet'];

                    }

                    if (_.has(this.configDetails, "config.petiApprovReqPWDDoc") && false) {

                        this.config['petiApprovReqPWDDoc'] = this.configDetails['config']['petiApprovReqPWDDoc'];

                    }

                    if (_.has(this.configDetails, "config.isPtnrActAsUSCISFormsPreparer")) {

                        this.config['isPtnrActAsUSCISFormsPreparer'] = this.configDetails['config']['isPtnrActAsUSCISFormsPreparer'];

                    }

                    if (_.has(this.configDetails['config'], 'contactInfoOfG28Form') && this.checkProperty(this.configDetails, 'config', 'contactInfoOfG28Form')) {

                        let dtVal = this.checkProperty(this.configDetails, 'config', 'contactInfoOfG28Form')

                        let findObj = _.find(this.contatctInfoList, { "id": dtVal })

                        this.config['contactInfoOfG28Form'] = findObj;



                    } else {

                        let findObj = _.find(this.contatctInfoList, { "id": 'law_firm' })

                        if (findObj) {

                            this.config['contactInfoOfG28Form'] = findObj;

                        }

                    }





                    if (_.has(this.configDetails, "config.prefillCountryInQuestionnaire")) {

                        this.config['prefillCountryInQuestionnaire'] = this.configDetails['config']['prefillCountryInQuestionnaire'];

                    }

                    //    if(_.has(this.configDetails ,"config.isI94DSExpiryDate"  )){  

                    //        this.config['isI94DSExpiryDate'] = this.configDetails['config']['isI94DSExpiryDate']; 

                    //    } 



                    if (_.has(this.configDetails, "config.allowToAddLCALayers")) {

                        this.config['allowToAddLCALayers'] = this.configDetails['config']['allowToAddLCALayers'];

                    }



                    if (_.has(this.configDetails, "config.addressEntityIOrHomeForLCA")) {

                        this.config['addressEntityIOrHomeForLCA'] = this.configDetails['config']['addressEntityIOrHomeForLCA'];

                    }



                    if (_.has(this.configDetails, "config.multipleJobDutiesForLCA")) {

                        this.config['multipleJobDutiesForLCA'] = this.configDetails['config']['multipleJobDutiesForLCA'];

                    }

                    if (_.has(this.configDetails, "config.multiEduDetailsForLCA")) {

                        this.config['multiEduDetailsForLCA'] = this.configDetails['config']['multiEduDetailsForLCA'];

                    }



                    if (_.has(this.configDetails, "config.yearsOfExpRequiredForLCA")) {

                        this.config['yearsOfExpRequiredForLCA'] = this.configDetails['config']['yearsOfExpRequiredForLCA'];

                    }

                    if (_.has(this.configDetails, "config.canInternalUsersSeeAllCapCases")) {

                        this.config['canInternalUsersSeeAllCapCases'] = this.configDetails['config']['canInternalUsersSeeAllCapCases'];

                    } else {

                        this.config['canInternalUsersSeeAllCapCases'] = false;

                    }
                    if(_.has(this.configDetails ,"config.disableH1bCapRegForPetitioner"  )){
                        this.config['disableH1bCapRegForPetitioner'] = this.configDetails['config']['disableH1bCapRegForPetitioner'];
                    }else{
                        this.config['disableH1bCapRegForPetitioner'] = false;
                    }





                    if (_.has(this.configDetails, "config.taskApprovalRequired")) {

                        this.config['taskApprovalRequired'] = this.configDetails['config']['taskApprovalRequired'];

                    } 

                    if (_.has(this.configDetails, "config.requiredQBForInvoice")) {

                        this.config['requiredQBForInvoice'] = this.configDetails['config']['requiredQBForInvoice'];

                    }
                    if (_.has(this.configDetails, "config.showCustomReports")) {

                        this.config['showCustomReports'] = this.configDetails['config']['showCustomReports'];

                        }





                    if (_.has(this.configDetails, "commuEmails")) {

                        this.config['commuEmails'] = this.configDetails['commuEmails'];

                        this.formatEmail();

                    }



                    if (_.has(this.configDetails, "config.caseDeadlineDays")) {

                        this.config['caseDeadlineDays'] = this.configDetails['config']['caseDeadlineDays'];

                    }

                    if (_.has(this.configDetails, "config.rfeCaseDeadlineDays")) {

                        this.config['rfeCaseDeadlineDays'] = this.configDetails['config']['rfeCaseDeadlineDays'];

                    }
                    if (_.has(this.configDetails, "config.invoicePaymentTermsDays")) {

                        this.config['invoicePaymentTermsDays'] = this.configDetails['config']['invoicePaymentTermsDays'];

                    }





                    if (_.has(this.configDetails, "config.priorI94DeadlineDays")) {

                        this.config['priorI94DeadlineDays'] = this.configDetails['config']['priorI94DeadlineDays'];

                    }

                    if (_.has(this.configDetails, "config.remindPtnrInfoUpdateDays")) {

                        this.config['remindPtnrInfoUpdateDays'] = this.configDetails['config']['remindPtnrInfoUpdateDays'];

                    }



                    if (_.has(this.configDetails, "config.advCoolingPeriod")) {

                        this.config['advCoolingPeriod'] = this.configDetails['config']['advCoolingPeriod'];

                    }

                    if (_.has(this.configDetails, "config.advMinDuration")) {

                        this.config['advMinDuration'] = this.configDetails['config']['advMinDuration'];

                    }



                    if (_.has(this.configDetails, "config.priorFormsEffectiveDays")) {

                        this.config['priorFormsEffectiveDays'] = this.configDetails['config']['priorFormsEffectiveDays'];

                    }

                    if (_.has(this.configDetails, "config.permFileDaysAfterLastAdv")) {

                        this.config['permFileDaysAfterLastAdv'] = this.configDetails['config']['permFileDaysAfterLastAdv'];

                    }



                    if (_.has(this.configDetails, "config.tenantDefaultTZ")) {

                        let selectedTimeZone = _.find(this.timeZoneList, { 'id': this.configDetails['config']['tenantDefaultTZ'] });



                        this.config['tenantDefaultTZ'] = selectedTimeZone;

                    }



                    if (_.has(this.configDetails, "config.ptnrAttorneySignByInternal")) {

                        this.config['ptnrAttorneySignByInternal'] = this.configDetails['config']['ptnrAttorneySignByInternal'];

                    }



                    //addressEntityIOrHomeForLCA 

                    if (_.has(this.configDetails, "config.addressEntityIOrHomeForLCA")) {

                        this.config['addressEntityIOrHomeForLCA'] = this.configDetails['config']['addressEntityIOrHomeForLCA'];

                    }

                    if (_.has(this.configDetails, "config.multipleJobDutiesForLCA")) {

                        this.config['multipleJobDutiesForLCA'] = this.configDetails['config']['multipleJobDutiesForLCA'];

                    }

                    if (_.has(this.configDetails, "config.multiEduDetailsForLCA")) {

                        this.config['multiEduDetailsForLCA'] = this.configDetails['config']['multiEduDetailsForLCA'];

                    }

                    //filingFeeCategoryType 

                    if (_.has(this.configDetails, "config.filingFeeCategoryType")) {

                        this.config['filingFeeCategoryType'] = this.configDetails['config']['filingFeeCategoryType'];

                    }

                    //preSOCCodeMandatoryLCA 

                    if (_.has(this.configDetails, "config.preSOCCodeMandatoryLCA")) {

                        this.config['preSOCCodeMandatoryLCA'] = this.configDetails['config']['preSOCCodeMandatoryLCA'];

                    }





                    //ptnrAttorneySignByInternal 



                    // "defaultCourierIds":null, 

                    //  defaultCourierDetails:null, 

                    if (_.has(this.configDetails, "config.defaultCourierIds")) {

                        this.config['defaultCourierIds'] = this.configDetails['config']['defaultCourierIds'];

                        if (this.checkProperty(this.masterCourierList, 'length') > 0) {

                            this.config['defaultCourierDetails'] = _.filter(this.masterCourierList, (item) => {

                                return this.config['defaultCourierIds'].indexOf(item.id) > -1



                            })



                        }

                    }





                    this.config['reminders'] = {

                        pwdExpiry: {

                            config: [

                                {

                                    days: '',

                                    showError: false

                                },

                            ]

                        },

                        i140: {

                            config: [

                                {

                                    days: '', showError: false

                                },

                            ]

                        },

                        sponQuestionnire: {

                            config: [

                                {

                                    days: '', showError: false

                                },

                            ]

                        },

                        caseSeleByUscisInLotteryDays: {

                            whoWillSendReminder: [],

                            config: [



                                {

                                    days: ''

                                },

                            ]

                        }

                        ,

                        priorToExpiryDaysH1b: {

                            whoWillSendReminder: [],

                            config: [



                                {

                                    days: ''

                                },

                            ]

                        },

                        lcaSubAndQuestNotSubBriefDays: {

                            whoWillSendReminder: [],

                            config: [



                                {

                                    days: ''

                                },

                            ]

                        },

                        pwdCertOrBeforeExpiryDays: {

                            whoWillSendReminder: [],

                            config: [



                                {

                                    days: ''

                                },

                            ]

                        },

                        lastAdvReleaseBriefDays: {

                            whoWillSendReminder: [],

                            config: [



                                {

                                    days: ''

                                },

                            ]

                        },

                        priorToExpiryPermDays: {

                            whoWillSendReminder: [],

                            config: [



                                {

                                    days: ''

                                },

                            ]

                        },

                        i140ApprovedDuringDays: {

                            whoWillSendReminder: [],

                            config: [



                                {

                                    days: ''

                                },

                            ]

                        },

                        gcEmpi485ApprovedDays: {

                            whoWillSendReminder: [],

                            config: [



                                {

                                    days: ''

                                },

                            ]

                        },

                        i130ApprovedDuringDays: {

                            whoWillSendReminder: [],

                            config: [



                                {

                                    days: ''

                                },

                            ]

                        },

                        gcfamilyi485ApprovedDays: {

                            whoWillSendReminder: [],

                            config: [



                                {

                                    days: ''

                                },

                            ]

                        },

                        priorToExpiryl1aOrl1b: {

                            whoWillSendReminder: [],

                            config: [



                                {

                                    days: ''

                                },

                            ]

                        },

                        l1i140ApprovedDuringDays: {

                            whoWillSendReminder: [],

                            config: [



                                {

                                    days: ''

                                },

                            ]

                        }

                    }

                    if (_.has(this.configDetails, "config.reminders")) {

                        this.config['reminders'] = this.configDetails['config']['reminders'];

                        _.forEach(this.config['reminders']['pwdExpiry']['config'], (item) => {

                            item['showError'] = false

                        })

                        _.forEach(this.config['reminders']['i140']['config'], (item) => {

                            item['showError'] = false

                        })

                        _.forEach(this.config['reminders']['sponQuestionnire']['config'], (item) => {

                            item['showError'] = false

                        })

                        _.forEach(this.config['reminders']['caseSeleByUscisInLotteryDays']['config'], (item) => {

                            item['showError'] = false

                        })

                        _.forEach(this.config['reminders']['priorToExpiryDaysH1b']['config'], (item) => {

                            item['showError'] = false

                        })

                        _.forEach(this.config['reminders']['lcaSubAndQuestNotSubBriefDays']['config'], (item) => {

                            item['showError'] = false

                        })

                        _.forEach(this.config['reminders']['pwdCertOrBeforeExpiryDays']['config'], (item) => {

                            item['showError'] = false

                        })

                        _.forEach(this.config['reminders']['lastAdvReleaseBriefDays']['config'], (item) => {

                            item['showError'] = false

                        })

                        _.forEach(this.config['reminders']['priorToExpiryPermDays']['config'], (item) => {

                            item['showError'] = false

                        })

                        _.forEach(this.config['reminders']['i140ApprovedDuringDays']['config'], (item) => {

                            item['showError'] = false

                        })

                        _.forEach(this.config['reminders']['gcEmpi485ApprovedDays']['config'], (item) => {

                            item['showError'] = false

                        })

                        _.forEach(this.config['reminders']['i130ApprovedDuringDays']['config'], (item) => {

                            item['showError'] = false

                        })

                        _.forEach(this.config['reminders']['gcfamilyi485ApprovedDays']['config'], (item) => {

                            item['showError'] = false

                        })

                        _.forEach(this.config['reminders']['priorToExpiryl1aOrl1b']['config'], (item) => {

                            item['showError'] = false

                        })

                        _.forEach(this.config['reminders']['l1i140ApprovedDuringDays']['config'], (item) => {

                            item['showError'] = false

                        })

                    }

                    if (this.config['reminders']['pwdExpiry']['config'].length <= 0) {

                        this.config['reminders']['pwdExpiry']['config'] = [{ days: '', showError: false }]

                    }

                    if (this.config['reminders']['i140']['config'].length <= 0) {

                        this.config['reminders']['i140']['config'] = [{ days: '', showError: false }]

                    }

                    if (this.config['reminders']['sponQuestionnire']['config'].length <= 0) {

                        this.config['reminders']['sponQuestionnire']['config'] = [{ days: '', showError: false }]

                    }

                    if (this.config['reminders']['caseSeleByUscisInLotteryDays']['config'].length <= 0) {

                        this.config['reminders']['caseSeleByUscisInLotteryDays']['config'] = [{ days: '', showError: false }]

                    }

                    if (this.config['reminders']['priorToExpiryDaysH1b']['config'].length <= 0) {

                        this.config['reminders']['priorToExpiryDaysH1b']['config'] = [{ days: '', showError: false }]

                    }

                    if (this.config['reminders']['lcaSubAndQuestNotSubBriefDays']['config'].length <= 0) {

                        this.config['reminders']['lcaSubAndQuestNotSubBriefDays']['config'] = [{ days: '', showError: false }]

                    }

                    if (this.config['reminders']['pwdCertOrBeforeExpiryDays']['config'].length <= 0) {

                        this.config['reminders']['pwdCertOrBeforeExpiryDays']['config'] = [{ days: '', showError: false }]

                    }

                    if (this.config['reminders']['lastAdvReleaseBriefDays']['config'].length <= 0) {

                        this.config['reminders']['lastAdvReleaseBriefDays']['config'] = [{ days: '', showError: false }]

                    }

                    if (this.config['reminders']['priorToExpiryPermDays']['config'].length <= 0) {

                        this.config['reminders']['priorToExpiryPermDays']['config'] = [{ days: '', showError: false }]

                    }

                    if (this.config['reminders']['i140ApprovedDuringDays']['config'].length <= 0) {

                        this.config['reminders']['i140ApprovedDuringDays']['config'] = [{ days: '', showError: false }]

                    }

                    if (this.config['reminders']['gcEmpi485ApprovedDays']['config'].length <= 0) {

                        this.config['reminders']['gcEmpi485ApprovedDays']['config'] = [{ days: '', showError: false }]

                    }

                    if (this.config['reminders']['i130ApprovedDuringDays']['config'].length <= 0) {

                        this.config['reminders']['i130ApprovedDuringDays']['config'] = [{ days: '', showError: false }]

                    }

                    if (this.config['reminders']['gcfamilyi485ApprovedDays']['config'].length <= 0) {

                        this.config['reminders']['gcfamilyi485ApprovedDays']['config'] = [{ days: '', showError: false }]

                    }

                    if (this.config['reminders']['priorToExpiryl1aOrl1b']['config'].length <= 0) {

                        this.config['reminders']['priorToExpiryl1aOrl1b']['config'] = [{ days: '', showError: false }]

                    }

                    if (this.config['reminders']['l1i140ApprovedDuringDays']['config'].length <= 0) {

                        this.config['reminders']['l1i140ApprovedDuringDays']['config'] = [{ days: '', showError: false }]

                    }





                    if (this.checkProperty(this.configDetails, 'config', 'handlePwdActivityUsers')) {

                        this.processHandlePwdActivityUsers();

                        // handlePwdActivityUsers 

                    }

                    if (this.checkProperty(this.configDetails, 'config', 'whoCanPerformAllCapActions')) {

                        this.processHandlecapHandlers();

                        // whoCanPerformAllCapActions 

                    }

                    if (_.has(this.configDetails['config'], 'whoWillReassignCase') && this.checkProperty(this.configDetails, 'config', 'whoWillReassignCase')) {

                        this.processwhoWillReassignCase();

                    } else {

                        let findObj = _.find(this.allUserRoles, { "id": 3 })

                        if (findObj) {

                            this.configDetails['config']['whoWillReassignCase'].push(findObj)

                        }

                    }

                })





        },

        processwhoWillReassignCase() {

            if (this.checkProperty(this.configDetails, 'config', 'whoWillReassignCase') && this.checkProperty(this.configDetails['config'], 'whoWillReassignCase', 'length') > 0) {

                this.config['whoWillReassignCase'] = _.filter(this.allUserRoles, (rol) => {

                    return this.configDetails['config']['whoWillReassignCase'].indexOf(rol['id']) > -1

                })



            } else {

                let findObj = _.find(this.allUserRoles, { "id": 3 })

                if (findObj) {

                    this.configDetails['config']['whoWillReassignCase'].push(findObj)

                    this.config['whoWillReassignCase'].push(findObj)



                }

            }

        },

        processHandlePwdActivityUsers() {





            if (this.checkProperty(this.configDetails, 'config', 'handlePwdActivityUsers')) {

                this.config['handlePwdActivityUsers'] = _.filter(this.allUserRoles, (rol) => {

                    return this.configDetails['config']['handlePwdActivityUsers'].indexOf(rol['id']) > -1

                })



            }

        },

        processHandlecapHandlers() {

            if (this.checkProperty(this.configDetails, 'config', 'whoCanPerformAllCapActions')) {

                this.config['whoCanPerformAllCapActions'] = _.filter(this.allUserRoles, (rol) => {

                    return this.configDetails['config']['whoCanPerformAllCapActions'].indexOf(rol['id']) > -1

                })



            }

        },



        getTimeZoneList() {

            let postData = {

                page: 1,

                perpage: 1000,

                category: "timezone"

            }

            this.$store.dispatch("getMasterData", postData).then((res) => {

                _.forEach(res['list'], (item) => {

                    item.name = item['name'] + ' (' + item.id + ')';

                    this.timeZoneList.push(item);



                })



                this.getGlobalConfigDetails();



            })

        }



    },



    mounted() {

        this.getGraduatedYears();

        this.getAllSeasonsList();

        this.getUserRoles();

        this.username = this.$store.state.user.name;

        this.roleId = this.$store.state.user["roleId"][0];

        this.getCourierList();

        this.getTimeZoneList()







    },

    computed: {

        selectedSeasonYear() {

            return (data) => {

                let retrunVal = null;

                let year = parseInt(data)

                if (year && year > 2) {

                    let dt = parseInt(year) - 2

                    let date = dt + '-04-01';

                    retrunVal = date;

                }

                return retrunVal

            }

        },

        showMoreBtn() {

            return (category) => {

                if (category == 'pwdExpiry') {

                    let itemLength = this.checkProperty(this.config['reminders'][category]['config'], 'length');

                    let lastIndexx = parseInt(itemLength) - 1;

                    if (this.checkProperty(this.config['reminders'][category]['config'][lastIndexx], 'days') == 1 || this.checkProperty(this.config['reminders'][category]['config'][lastIndexx], 'days') == 0) {

                        return false

                    } else {

                        return true

                    }

                }

                else {

                    let itemLength = this.checkProperty(this.config['reminders'][category]['config'], 'length');

                    let lastIndexx = parseInt(itemLength) - 1;

                    if (this.checkProperty(this.config['reminders'][category]['config'][lastIndexx], 'days') == 999) {

                        return false

                    } else {

                        return true

                    }



                }



            }

        },

        getMaxValue() {

            return (index) => {

                if (index > 0) {

                    let item = this.config['reminders']['pwdExpiry']['config'][index - 1];

                    if (_.get(item, 'days')) {

                        let days = _.get(item, 'days')

                        return parseInt(days) - 1;

                    } else {

                        return null

                    }

                } else {

                    return null

                }

            }

        }

    }

};

</script> 